// get a cookie by name
function getCookie(name) {
	var value = "; " + document.cookie;
	var parts = value.split("; " + name + "=");
	if (parts.length == 2) return parts.pop().split(";").shift();
}

// set a cookie
function setCookie(name, value, days = 365) {
	// get domain name from the current url
	var domain = window.location.hostname;

	var expires = "";
	if (days) {
		var date = new Date();
		date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
		expires = "; expires=" + date.toUTCString();
	}
	document.cookie =
		name + "=" + value + ";" + expires + ";path=/; domain=" + domain;
}

//export the functions
module.exports = { getCookie, setCookie };
